<template>
  <BaseVeeForm
    :action="tryCreateNote"
    v-slot="{ isPending, invalid }"
    class="space-y-6"
    @success="$emit('success')"
    @failure="$emit('failure')"
  >
    <ValidationProvider rules="required" name="content" slim vid="content">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="content"> Description </BaseFormLabel>
          <BaseFormTextarea
            id="content"
            rows="10"
            v-model="formData.content"
            :disabled="isPending"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="flex space-x-2">
      <BaseButton primary :disabled="isPending || invalid"> Create Note </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'NoteForm',
  props: {
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        content: '',
      },
    };
  },
  methods: {
    async tryCreateNote() {
      try {
        await this.action(this.formData);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
